import { create } from 'zustand'

/** The spring the operator is inspecting — surfaced in the Control Plane rail. */
export interface SelectedSpring {
  id: string
  name: string
  display: string
  source_type: string | null
  url: string | null
  schedule: string | null
  scheduleHuman: string
  enabled: boolean
  owner_product: string | null
  critical: boolean
  health: { status?: string; last_run?: string; detail?: string } | null
  /** Catalog garnish (Springs-page pass) — optional so older callers stay valid. */
  gloss?: string
  sourceClass?: string
  tags?: string[]
  /** What this spring FILLS into the verse — entity + relation types it lands. */
  produces?: { entities: string[]; relations: string[] }
}

interface SpringSelectionState {
  selected: SelectedSpring | null
  select: (s: SelectedSpring | null) => void
}

export const useSpringSelection = create<SpringSelectionState>((set) => ({
  selected: null,
  select: (selected) => set({ selected }),
}))
